import { useQuery } from "@tanstack/react-query";
import { getOpportunities } from "@/helpers/apis";
import { GET_OPPORTUNITIES_DATA } from "../constants";
import { useExplorerFiltersFromUrl } from "./useExplorerFiltersFromUrl";

interface UseOpportunitiesQueryOptions {
  enabled?: boolean;
}

export const useOpportunitiesQuery = (options: UseOpportunitiesQueryOptions = {}) => {
  const { enabled = true } = options;
  const { filterParams } = useExplorerFiltersFromUrl();

  return useQuery({
    queryKey: [GET_OPPORTUNITIES_DATA, filterParams],
    queryFn: () => getOpportunities(filterParams),
    enabled,
  });
};
